"use client"

import React, { ReactNode } from "react"
import {
    Modal,
    ModalContent,
    ModalBody,
    Button,
    useDisclosure,
} from "@heroui/react"

interface SelfContainedModalProps {
    triggerLabel?: string
    children?: ReactNode
    trigger?: ReactNode
    classname?: string
    open?: boolean
    onOpenChange?: (isOpen: boolean) => void
}

export default function SelfContainedModal({
    triggerLabel = "Open Modal",
    children,
    trigger,
    classname,
    open,
    onOpenChange
}: SelfContainedModalProps) {
    const disclosure = useDisclosure()
    const isControlled = open !== undefined
    const isOpen = isControlled ? open : disclosure.isOpen
    const handleOpen = isControlled
        ? () => onOpenChange?.(true)
        : disclosure.onOpen

    const handleOpenChange = isControlled
        ? onOpenChange
        : disclosure.onOpenChange

    return (
        <>
            {trigger ? (
                <span onClick={handleOpen} className="cursor-pointer">
                    {trigger}
                </span>
            ) : (
                <Button onPress={handleOpen}>
                    {triggerLabel}
                </Button>
            )}

            <Modal
                className={classname}
                placement="center"
                isOpen={isOpen}
                onOpenChange={handleOpenChange}
                size="4xl"
                scrollBehavior="outside"
            >
                <ModalContent>
                    <ModalBody>
                        {children}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}